import { render, staticRenderFns } from "./AddSurveyGlobalSetting.vue?vue&type=template&id=bb26e7e8&scoped=true"
import script from "./AddSurveyGlobalSetting.vue?vue&type=script&lang=js"
export * from "./AddSurveyGlobalSetting.vue?vue&type=script&lang=js"
import style0 from "./AddSurveyGlobalSetting.vue?vue&type=style&index=0&id=bb26e7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb26e7e8",
  null
  
)

export default component.exports